import Cookies from 'js-cookie'
import {
    InlineOptions
} from './fancybox-options'

const expiration = 1 // days

var cookieNewsletter = Cookies.get('newsletter-popup');

// Debug
// var cookieNewsletter = false;

if (!cookieNewsletter) {
    setTimeout(function () {
        $.fancybox.open({
            src: '#newsletter',
            type: 'inline',
            opts: {
                animationEffect: "zoom-in-out",
                animationDuration: 500,
                btnTpl: InlineOptions.btnTpl,
                baseClass: 'fancybox-bg-gray',
                beforeShow: function (instance, current) {
                    $('.lazy-now').Lazy();
                },
                afterClose: function () {
                    Cookies.set('newsletter-popup', 'shown', {
                        expires: expiration
                    });
                }
            },
        });
    }, 3000);
} else {
    $('#newsletter').remove();
}


// WEBPACK FOOTER //
// ./src/js/imports/newsletter-popup.js